enum ResidencyWorkflowOptions {
	None,
	UseAutocomplete = 1,
	UseRemoteZones = UseAutocomplete << 1
}

export default ResidencyWorkflowOptions;
